export enum MemberRole {
  Staff = 0,
  Administrator = 1,
}

export enum CompanyType {
  LimitedCompany = 'LimitedCompany',
  LimitedLiabilityPartnership = 'LimitedLiabilityPartnership',
  SoleTrader = 'SoleTrader',
  Partnership = 'Partnership',
}

export enum VatSchedule {
  JanAprJulOct = 0,
  FebMayAugNov = 1,
  MarJunSepDec = 2,
  Monthly = 3,
  Yearly = 4,
}

export enum VatDefaultPeriod {
  First = 0,
  Current = 1,
}

export enum BookkeepingFrequency {
  Weekly = 0,
  Monthly = 1,
  // WeeklyAndMonthly = 2,
  Quarterly = 3,
  Yearly = 4,
}

export enum PayrollFrequency {
  Weekly = 0,
  Fortnightly = 1,
  Monthly = 2,
  // WeeklyAndMonthly = 3,
  Quarterly = 4,
  Yearly = 5,
}

export enum JobScheduleType {
  OneOff = 0,
  // Daily = 1,
  // DailyWorkingDaysOnly = 2,
  Weekly = 3,
  // TwoWeekly = 4,
  // FourWeekly = 5,
  Monthly = 6,
  // TwoMonthly = 7,
  Quarterly = 8,
  // FourMonthly = 9,
  // SixMonthly = 10,
  Yearly = 11,
  // TwoYearly = 12,
  // ThreeYearly = 13,
  // FourYearly = 14,
  // FiveYearly = 15,
}

export enum TaskStatus {
  Unscheduled = 'Unscheduled',
  Scheduled = 'Scheduled',
  StartDue = 'StartDue',
  Started = 'Started',
  CompletionDue = 'CompletionDue',
  Completed = 'Completed',
  DeadlineDue = 'DeadlineDue',
}

export enum RecordsStatus {
  Required = 'Required',
  Received = 'Received',
  NotRequired = 'NotRequired',
}

export enum RecurringTaskStatus {
  Scheduled = 'Scheduled',
  Completed = 'Completed',
}

export enum ClientType {
  Company = 'Client',
  Individual = 'Individual',
}

export enum DueTimeFrameType {
  Accounts = 'Accounts',
  AmlCheck = 'AmlCheck',
  Bookkeeping = 'Bookkeeping',
  CisReturn = 'CisReturn',
  ConfirmationStatement = 'ConfirmationStatement',
  Payroll = 'Payroll',
  TaxReturn = 'TaxReturn',
  VatReturn = 'VatReturn',
}

export enum DueTimeFrame {
  Overdue = 'Overdue',
  Due = 'Due',
  DueToday = 'DueToday',
  DueTomorrow = 'DueTomorrow',
  DueThisWeek = 'DueThisWeek',
  DueNextWeek = 'DueNextWeek',
  DueThisMonth = 'DueThisMonth',
  DueNextMonth = 'DueNextMonth',
  DueMonthAfterNext = 'DueMonthAfterNext',
  DueWithin30Days = 'DueWithin30Days',
  DueWithin60Days = 'DueWithin60Days',
  DueWithin90Days = 'DueWithin90Days',
  DueWithin30To60Days = 'DueWithin30To60Days',
  DueWithin60To90Days = 'DueWithin60To90Days',
}

export enum DashboardView {
  CompanyDeadlines = 'CompanyDeadlines',
  TaskDeadlines = 'TaskDeadlines',
}

export enum CompanySmartTaskType {
  AccountsPeriodEnd = 'AccountsPeriodEnd',
  AccountsDue = 'AccountsDue',
  AmlCheckDue = 'AmlCheckDue',
  BookkeepingDue = 'BookkeepingDue',
  CompanyCreated = 'CompanyCreated',
  CisPeriodEnd = 'CisPeriodEnd',
  CisReturnDue = 'CisReturnDue',
  ConfirmationStatementDue = 'ConfirmationStatementDue',
  EngagementSignatureRequired = 'EngagementSignatureRequired',
  PayrollDue = 'PayrollDue',
  TaxPeriodEnd = 'TaxPeriodEnd',
  TaxReturnDue = 'TaxReturnDue',
  TaxPaymentDue = 'TaxPaymentDue',
  VatPeriodEnd = 'VatPeriodEnd',
  VatReturnDue = 'VatReturnDue',
}

export enum IndividualSmartTaskType {
  AmlCheckDue = 'AmlCheckDue',
  EngagementSignatureRequired = 'EngagementSignatureRequired',
  IndividualCreated = 'IndividualCreated',
  TaxPeriodEnd = 'TaxPeriodEnd',
  TaxReturnDue = 'TaxReturnDue',
}

export const SmartTaskType = {
  ...CompanySmartTaskType,
  ...IndividualSmartTaskType,
};

export enum CompanyUpdateOnCompletion {
  AccountsLastMadeUpTo = 'AccountsLastMadeUpTo',
  AmlLastChecked = 'AmlLastChecked',
  CisLastMadeUpTo = 'CisLastMadeUpTo',
  ConfirmationStatementLastMadeUpTo = 'ConfirmationStatementLastMadeUpTo',
  BookkeepingLastMadeUpTo = 'BookkeepingLastMadeUpTo',
  EngagementSigned = 'EngagementSigned',
  PayrollLastMadeUpTo = 'PayrollLastMadeUpTo',
  TaxReturnLastMadeUpTo = 'TaxLastMadeUpTo',
  TaxPaymentLastMadeUpTo = 'TaxLastPaidUpTo',
  VatLastMadeUpTo = 'VatLastMadeUpTo',
}

export enum IndividualUpdateOnCompletion {
  AmlLastChecked = 'AmlLastChecked',
  EngagementSigned = 'EngagementSigned',
  TaxReturnLastMadeUpTo = 'TaxLastMadeUpTo',
}

export const UpdateOnCompletion = {
  ...CompanyUpdateOnCompletion,
  ...IndividualUpdateOnCompletion,
};

// PF1-3; The feature request only mentions Low, Medium, and High priorities.
// We've reserved space for one lower (Deferred) and one higher (Urgent) priority
// to allow future extension without breaking changes. These are currently commented out
// as they are not part of the current scope.
export enum Priority {
  // Deferred = 0,
  Low = 1,
  Medium = 2,
  High = 3,
  // Urgent = 4,
}
